import { apiRoutes } from '@features/campaigns/details/consts/apiRoutes';
import { CampaignDetails } from '@features/campaigns/shared/types/campaign.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { CampaignId } from '@shared/types/campaign';

export async function approveCampaign(campaignId: CampaignId): Promise<CampaignDetails | null> {
  return await apiClient.post<void, CampaignDetails>(apiRoutes.approveCampaign(campaignId));
}
